import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import {
    selectLoggedIn, selectLoggingIn, selectLoginType,
} from "../../../ducks/auth";

import Styles from "./secure-route.module.scss";

function SecureRoute(WrappedComponent) {
    return class extends Component {
        componentWillUpdate(nextProps) {
            if (nextProps.shouldRedirect) {
                this.props.history.push("/login");
            }
        }
    
        render() {
            const { isAuthenticated } = this.props;
            const children = isAuthenticated && <WrappedComponent {...this.props} />;
            const spinnerOverlay = (
                <div className={Styles.secureRouteOverlay} data-visible={!isAuthenticated}>
                    <div className={Styles.secureRouteSpinner}>
                        <div className={Styles.spinnerBounceOne}></div>
                        <div className={Styles.spinnerBounceTwo}></div>
                    </div>
                    <label className={Styles.spinnerLabel}>Authenticating</label>
                </div>
            )
          
            return (
                <React.Fragment>
                    {spinnerOverlay}
                    {children}
                </React.Fragment>
            );
        }
    };
}
  
const mapStateToProps = (state, props) => {
    return {
        isAuthenticated: selectLoggedIn(state),
        loggingIn: selectLoggedIn(state),
        // We should redirect when:
        // Not logged in, AND Tried to use a token, AND Token didnt work
        shouldRedirect: !selectLoggedIn(state) && selectLoginType(state) === "token" && !selectLoggingIn(state)
    };
};
const mapDispatchToProps = {};

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withRouter,
    SecureRoute
);



// WEBPACK FOOTER //
// ./src/pages/helpers/secure-route/secure-route.js